<template>
  <PasswordPolicy />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
